import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType, CommonRoutes,
} from 'app/enums/common.enums'
import {
    LeaseType,
} from 'app/enums/label.enums'

import {
    kamUpcoming,
} from '../KamDashboard.types'

const kamUpcomingConfig: SkyNetTableConfig<keyof kamUpcoming> = {
    name: 'kamUpcoming',
    tabs: [{
        name: 'Upcoming Quotes',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'quoteNumber',
                labelKey: 'AccountQuotes.quoteNumber',
            },
            {
                name: 'quotedForCompanyLocationName',
                labelKey: 'AccountQuotes.quotedForCompany',
            },
            {
                name: 'accountName',
                labelKey: 'AccountLane.accountCompanyName',
                filterField: 'accountName',
                filterType: FilterType.Array,
            },
            {
                name: 'leaseType',
                labelKey: 'AccountLane.leaseType',
                filterField: 'leaseType',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: LeaseType,
            },
            {
                name: 'pricingResponsible',
                labelKey: 'AccountQuotes.pricingResponsible',
                componentName: 'List',
            },
            {
                name: 'createdBy',
                labelKey: 'KamDashboard.requestor',
                sorting: false,
            },
            {
                name: 'lanesToBePriced',
                labelKey: 'KamDashboard.totalLanes',
                sorting: false,
            },
            {
                name: 'lastUpdated',
                labelKey: 'KamDashboard.lastUpdated',
                sorting: false,
                componentName: 'DateTimeCell',
            },
        ],
    }],
}

export default kamUpcomingConfig
